import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as myGlobals from '../../globals';
import { Configuration } from '../../app.configuration';

@Injectable()
export class DispatcherHomeService {
  private _getoffers = myGlobals.apiurl + 'customer/bookingHistory';
  private _getjobs = myGlobals.apiurl + 'customer/bookings/';
  private _singlebooking = myGlobals.apiurl + 'agents/jobs/';
  private _cancelservice =
    myGlobals.apiurl + 'customer/cancelBookingBeforeAccept';
  private _cancelserviceAfteraccept =
    myGlobals.apiurl + 'customer/cancelBookingAfterAccept';
  private _onebookingdetails = '';
  private _dispatcherLivepath = myGlobals.apiurl + 'customer/bookingPath/';
  private _cancelreasons =
    myGlobals.apiurl + 'customer/cancellationReasonCourier';
  private _cancelFee = myGlobals.apiurl + 'customer/cancellationFees/';
  private _negotiations = myGlobals.apiurl + 'customer/bookingDetails/';
  private _counter = myGlobals.apiurl + 'customer/respondToRequest';
  private _history =
    myGlobals.apiurl + 'agents/jobs/offers/negotiations/history';
  private _accept = myGlobals.apiurl + 'customer/respondToRequest';
  private _getdetUrl = '';
  private _bookingCounter = myGlobals.apiurl + 'customer/bookingCounter';
  private _pendingReviews = myGlobals.apiurl + 'customer/pendingReview';
  private _ratingRide = myGlobals.apiurl + 'customer/ratingTextCourier';
  private _reviewAndRating = myGlobals.apiurl + 'customer/reviewAndRating';
  private _postsupportAlert = myGlobals.apiurl + 'booking/supportAlert';
  private _post_start_job = myGlobals.apiurl + 'booking/receiverVerificationCode';
  private _favoritedriver = myGlobals.apiurl + 'customer/favouriteDriver';
  private _favoritedriver1 = myGlobals.apiurl + 'customer/favouriteDriver';
  constructor(private _http: HttpClient, private _conf: Configuration) { }

  getdet(user: any) {
    return this._http.get(this._getoffers, { headers: this._conf.header });
  }

  singleBooking(user: any) {
    return this._http.get(this._singlebooking + user.id, {
      headers: this._conf.header
    });
  }

  getjobs(user: any) {
    return this._http.get(
      this._getjobs + user.type + '/' + user.limit + '/' + user.skip,
      {
        headers: this._conf.header
      }
    );
  }

  negotiations(user: any) {
    return this._http.get(
      this._negotiations + user.bookingId + '/' + user.status,
      {
        headers: this._conf.header
      }
    );
  }
  emergencyBooking(user: any) {
    return this._http.post(this._postsupportAlert, user, { headers: this._conf.header });
  }
  history(user: any) {
    return this._http.post(this._history, user, { headers: this._conf.header });
  }
  counter_price(user: any) {
    return this._http.post(this._counter, user, { headers: this._conf.header });
  }
  accept_price(user: any) {
    return this._http.post(this._accept, user, { headers: this._conf.header });
  }
  cancelservice(user: any) {
    return this._http.put(this._cancelservice, user, {
      headers: this._conf.header
    });
  }

  getpendingreviews(user: any) {
    return this._http.get(this._pendingReviews, { headers: this._conf.header });
  }

  getratings(user: any) {
    return this._http.get(this._ratingRide, { headers: this._conf.header });
  }

  postreview(user: any) {
    return this._http.post(this._reviewAndRating, user, {
      headers: this._conf.header
    });
  }

  cancelserviceAfterAccept(user: any) {
    return this._http.put(this._cancelserviceAfteraccept, user, {
      headers: this._conf.header
    });
  }

  getsingalBooking(user: any) {
    return this._http.post(this._getdetUrl, user, {
      headers: this._conf.header
    });
  }

  livePath(user: any) {
    return this._http.get(this._dispatcherLivepath + user.bid, {
      headers: this._conf.header
    });
  }

  // GET Booking Count

  getBookingCounter(user: any) {
    return this._http.get(this._bookingCounter, { headers: this._conf.header });
  }

  // cancel reasons
  cancelreasons(type) {
    return this._http.get(`${this._cancelreasons}/${type}`, {
      headers: this._conf.header
    });
  }

  // cancellation fees
  cancelfees(user: any) {
    return this._http.get(this._cancelFee + user.bookingId, {
      headers: this._conf.header
    });
  }
  postJobStartByDriver(user: any) {
    return this._http.post(this._post_start_job, user, {
      headers: this._conf.header
    });
  }
  // START OF FAVORITE DRIVER APIS
  getfavdriver(user: any) {
    return this._http.get(this._favoritedriver, {
      headers: this._conf.header
    });
  }
  postfavdriver(user: any) {
    return this._http.post(this._favoritedriver, user, {
      headers: this._conf.header
    });
  }
  patchfavdriver(user: any) {
    return this._http.delete(this._favoritedriver + '/' + user.driverId, {
      headers: this._conf.header
    });
  }
}
